module.exports = __webpack_public_path__ + "img/photo2.31aa9fd8.jpg";